module.exports = __webpack_public_path__ + "static/img/more-zixun.a49f0b70.png";